import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Sticky from "Components/Sticky/index";
import { PageWrapperT5 } from "Components/Common/Wrapper/PageWrapper";
import moment from "moment";
import { Spacer } from "Components/Common/Spacer/index";
import { BackButtonT1 } from "Components/Common/Button/index";
import CardT1 from "./CardT1";
import CardT2 from "./CardT2";
import CardT3 from "./CardT3";
import CardT4 from "./CardT4";
import CardT5 from "./CardT5";
import Footer from "./Footer";
import {
  CREATE_SUPPLIER_CONTRACT,
  DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS,
  DOWNLOAD_UPLOADED_FILE,
  GET_CARGO_DETAILS_TYPES_LIST,
  GET_CARGO_MATERIAL_PACKING_TEMAPLATE,
  GET_CONSIGNOR_PICKUP_LOCATION_LIST,
  GET_HANDLING_INSTRUCTION_TYPES_LIST,
  GET_PACKING_TYPES_LIST,
  GET_SERVICE_MODE_TYPES_LIST,
  GET_SERVICE_TYPES_LIST,
  GET_SUPPLIER_DETAILS_RFQ,
  GET_VEHICLE_TYPES_LIST,
  SET_SUPPLIER_DETAILS_RFQ,
  TOAST_SUCCESS,
  UPDATE_SUPPLIER_CONTRACT_DETAILS,
  UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE,
  UPLOAD_DOCUMENT,
} from "Constants/actionConstants";
import ActionBlurLoader from "Components/ActionLoader/LoaderWithBlur";
import { isValueThere, isValueThereT1, toast } from "Utils/index";
import ModalT1 from "Components/Common/Modal/ModalT1";
import ModalCardT3 from "Components/EXIMCargoTracking/ModalCardT3";
import { getUser } from "Utils/storage";

export class SupplierRFQCreateRequest extends Component {
  constructor(props) {
    super(props);

    this.fromRef = React.createRef();
    this.addressRef = React.createRef();

    this.state = {
      createRequestPayload: {
        rfq_type: 1,
        consignor_details: {
          city: "",
          state: "",
          country:"",
          source_address: "",
          consignor_name: "",
          pin_code: "",
          consignor_code: "",
        },
        project_details: {
          project_name: "",
          project_id: "",
          po_name: "",
          po_number: "",
        },
        service_type: 1,
        service_type_name: "FTL",
        service_mode: [
          {
            id: 1,
            name: "Road",
          },
        ],
        cargo_details: [
          {
            id: 1,
            name: "Solid",
          },
        ],
        material_packing_list: [],
        packing_type: "",
        packing_type_name: "",
        handling_instructions: [1],
        temp_min: 0,
        temp_max: 0,
        temp_unit: 0,
        vehicle_details: {
          vehicle_type_name: "",
          vehicle_type: 0,
        },
        tentative_pickup_date: moment(new Date()),
        contact_details: {
          contact_person_name: "",
          contact_no: "",
        },
        supplier_docs: [],
        supplier_instruction: "",
        is_draft: false,
      },
      focusedDateForTentativePickUpDate: false,
      isTemperatureCardShown:false,
      isComponentDidMount:false,
    };


  }

  componentDidMount() {
    this.handleGetSupplierDetailsRfq();
    // this.handleGetConsignorPickupLocationList();
    this.handleGetServiceTypesList();
    this.handleGetServiceModeTypesList();
    this.handleGetCargoDetailsTypesList();
    this.handleGetCargoMaterialPackingTemaplate();
    this.handleGetHandlingInstructionTypesList();
    this.handleGetVehicleTypesList();
    this.handleGetPackingTypesList();
    // need to find solution
    setTimeout(()=>{
      this.handleSetIsComponentDidMount();
    },1000)
  }

  componentDidUpdate(prevProps, prevState) {
    const { createRequestPayload } = this.state;
    const { supplierDetailsRfq } = this.props;

    const C1 =
      prevState.createRequestPayload.service_type !==
      createRequestPayload.service_type;

    const C2 =
      prevProps.supplierDetailsRfq.rfq_id !== supplierDetailsRfq.rfq_id;

    if (C1) {
      this.handleGetServiceModeTypesList();
    }

    if (C2) {
      this.setState((prevState) => {
        const updateState = { ...prevState };
        updateState.createRequestPayload = {
          ...prevState.createRequestPayload,
          ...supplierDetailsRfq,
          tentative_pickup_date: moment(
            supplierDetailsRfq.tentative_pickup_date
          ),
        };
        return updateState;
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: SET_SUPPLIER_DETAILS_RFQ,
      payload: {},
    });
  }

  handleSetIsComponentDidMount = (data = {}) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.isComponentDidMount = true;
      return updateState;
    });
  };


  handleGetSupplierDetailsRfq= () => {
    const { dispatch,match } = this.props;

    const rfqId = match.params.rfqId
    const rfqType = match.params.rfqType

    const queryParams= {
      rfqId,
      rfqType
    }

    dispatch({ 
      type: GET_SUPPLIER_DETAILS_RFQ,
      queryParams
    });
  };

  handleGetSupplierDetailsRfq = () => {
    const { dispatch, match } = this.props;

    const rfqId = match.params.rfqId;
    const rfqType = match.params.rfqType;

    const queryParams = {
      rfqId,
      rfqType,
    };

    dispatch({
      type: GET_SUPPLIER_DETAILS_RFQ,
      queryParams,
    });
  };

  handleGetConsignorPickupLocationList = () => {
    const { dispatch } = this.props;

    dispatch({
      type: GET_CONSIGNOR_PICKUP_LOCATION_LIST,
    });
  };

  handleGetServiceTypesList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_SERVICE_TYPES_LIST,
    });
  };

  handleGetServiceModeTypesList = () => {
    const { dispatch } = this.props;
    const type = this.handleGetServiceTypeValue().service_type;
    const queryParams = {
      type,
    };
    dispatch({
      type: GET_SERVICE_MODE_TYPES_LIST,
      queryParams,
    });
  };

  handleGetCargoDetailsTypesList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_CARGO_DETAILS_TYPES_LIST,
    });
  };

  handleGetCargoMaterialPackingTemaplate = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_CARGO_MATERIAL_PACKING_TEMAPLATE,
    });
  };

  handleGetHandlingInstructionTypesList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_HANDLING_INSTRUCTION_TYPES_LIST,
    });
  };

  handleGetVehicleTypesList = () => {
    const { dispatch } = this.props;
    const user = getUser();

    const queryParams = {
      companyId: user.companyId,
      branchId: user.branchId,
    };

    dispatch({
      type: GET_VEHICLE_TYPES_LIST,
      queryParams,
    });
  };

  handleGetPackingTypesList = () => {
    const { dispatch } = this.props;
    const user = getUser();

    const queryParams = {
      companyId: user.companyId,
      branchId: user.branchId,
    };

    dispatch({
      type: GET_PACKING_TYPES_LIST,
      queryParams
    });
  };

  handleOnChangeForPickupLocation = (data = {}) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        consignor_details: {
          ...((prevState.createRequestPayload||{}).consignor_details || {}),
          ...data,
        },
      };
      return updateState;
    });
  };

  handleGetConsignorDetails = () => {
    const { createRequestPayload = {} } = this.state;

    const consignor_details = createRequestPayload.consignor_details || {};
    // const C1 = !!consignor_details.value;
    const C1 = true;
    if (C1) {
      return consignor_details;
    }
    return null;
  };

  handleGetAddressValue = () => {
    const { createRequestPayload = {} } = this.state;
    const consignor_details = createRequestPayload.consignor_details || {};
    return consignor_details.source_address;
  };

  handleOnChangeAddress = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        consignor_details: {
          ...prevState.createRequestPayload.consignor_details,
          [name]: value,
        },
      };
      return updateState;
    });
  };

  handleOnChangeForProjectDetails = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        project_details: {
          ...prevState.createRequestPayload.project_details,
          [name]: value,
        },
      };
      return updateState;
    });
  };

  handleGetProjectDetails = () => {
    const { createRequestPayload = {} } = this.state;
    const project_details = createRequestPayload.project_details || {};
    return project_details;
  };

  handleOnClickServiceType = (event, serviceTypeObj) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        service_type_name: serviceTypeObj.name,
        service_type: serviceTypeObj.value,
        service_mode: [],
      };
      return updateState;
    });
  };

  handleGetServiceTypeValue = () => {
    const { createRequestPayload = {} } = this.state;
    const serviceTypeObj = {
      service_type: createRequestPayload.service_type,
      service_type_name: createRequestPayload.service_type_name,
    };
    return serviceTypeObj;
  };

  handleGetSelectedServiceModeList = () => {
    const { createRequestPayload = {} } = this.state;
    const service_mode = createRequestPayload.service_mode;
    return service_mode;
  };

  handleToggleServiceMode = (serviceModeEle) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      const service_mode = prevState.createRequestPayload.service_mode;
      let updateServiceMode = [...prevState.createRequestPayload.service_mode];
      const indexOfServiceModeEle = service_mode.findIndex((ele) => {
        if (ele.id === serviceModeEle.value) {
          return true;
        } else {
          return false;
        }
      });

      if (indexOfServiceModeEle < 0) {
        const updateServiceModeEle = {
          id: serviceModeEle.value,
          name: serviceModeEle.name,
        };
        updateServiceMode.push(updateServiceModeEle);
      } else {
        updateServiceMode.splice(indexOfServiceModeEle, 1);
      }

      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        service_mode: updateServiceMode,
      };
      return updateState;
    });
  };

  handleGetSelectedCargoDetailsList = () => {
    const { createRequestPayload = {} } = this.state;
    const cargo_details = createRequestPayload.cargo_details;
    return cargo_details;
  };

  handleToggleCargoDetails = (cargoDetailsEle) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      const cargo_details = prevState.createRequestPayload.cargo_details;
      let updateCargoDetails = [
        ...prevState.createRequestPayload.cargo_details,
      ];
      const indexOfCargoDetailsEle = cargo_details.findIndex((ele) => {
        if (ele.id === cargoDetailsEle.value) {
          return true;
        } else {
          return false;
        }
      });

      if (indexOfCargoDetailsEle < 0) {
        const updateCargoDetailsEle = {
          id: cargoDetailsEle.value,
          name: cargoDetailsEle.name,
        };
        updateCargoDetails.push(updateCargoDetailsEle);
      } else {
        updateCargoDetails.splice(indexOfCargoDetailsEle, 1);
      }

      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        cargo_details: updateCargoDetails,
      };
      return updateState;
    });
  };

  handleDownloadCargoMaterialPackingTemaplateFile = () => {
    const { cargoMaterialPackingTemaplateLink } = this.props;
    const link = document.createElement("a");
    link.href = cargoMaterialPackingTemaplateLink;
    link.setAttribute("download", true);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleOnChangeForCargoMaterialPackingTemplateFile = (file) => {
    const { dispatch } = this.props;
    const formData = new FormData();
    formData.append("file", file);
    const onSuccess = (materialPackingList = []) => {
      this.setState((prevState) => {
        const updateState = { ...prevState };
        const updateMaterialPackingList = [
          ...prevState.createRequestPayload.material_packing_list,
          ...materialPackingList,
        ];
        updateState.createRequestPayload = {
          ...prevState.createRequestPayload,
          material_packing_list: updateMaterialPackingList,
        };
        return updateState;
      });
    };

    dispatch({
      type: UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE,
      payload: formData,
      onSuccess,
    });
  };

  handleGetMaterialPackingList = () => {
    const { createRequestPayload = {} } = this.state;
    const material_packing_list = createRequestPayload.material_packing_list;
    return material_packing_list;
  };

  handleOnClickForAddMaterialPackingBtn = () => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      const newObj = {
        package_number: "",
        type_of_packing: "",
        packing_type_id: null,
        item_number: "",
        packing_qty: 0,
        packing_unit: 0,
        material_des: "",
        desmet_package_no: "",
        gross_weight: 0,
        tare_weight: 0,
        length: 0,
        width: 0,
        height: 0,
        volume: 0,
        remarks: "",
      };
      const updateMaterialPackingList = [
        ...prevState.createRequestPayload.material_packing_list,
        newObj,
      ];
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        material_packing_list: updateMaterialPackingList,
      };
      return updateState;
    });
  };

  handleOnClickForRemoveMaterialPackingBtn = (indexOfMP) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };

      const updateMaterialPackingList = prevState.createRequestPayload.material_packing_list.filter(
        (ele, indOfMP) => {
          if (indexOfMP !== indOfMP) {
            return true;
          } else {
            return false;
          }
        }
      );

      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        material_packing_list: updateMaterialPackingList,
      };
      return updateState;
    });
  };

  handleOnChangeForMaterialPackingInputs = (event, indexOfMP, type) => {
    if (type === "type_of_packing") {
      this.setState((prevState) => {
        const updateState = { ...prevState };

        const updateMaterialPackingList = prevState.createRequestPayload.material_packing_list.map(
          (ele, indOfMP) => {
            if (indexOfMP === indOfMP) {
              const newEle = {
                ...ele,
                packing_type_id: !!event ? event.id : null,
                type_of_packing: !!event ? event.name : null,
              };
              return newEle;
            } else {
              return ele;
            }
          }
        );

        updateState.createRequestPayload = {
          ...prevState.createRequestPayload,
          material_packing_list: updateMaterialPackingList,
        };
        return updateState;
      });

      return;
    }

    const { name, value } = event.target;

    this.setState((prevState) => {
      const updateState = { ...prevState };

      const updateMaterialPackingList = prevState.createRequestPayload.material_packing_list.map(
        (ele, indOfMP) => {
          if (indexOfMP === indOfMP) {
            let volume = isValueThereT1(ele.volume) ? +ele.volume : 0;
            if (name === "length") {
              const length = isValueThereT1(value) ? +value : 0;
              const width = isValueThereT1(ele.width) ? +ele.width : 1;
              const height = isValueThereT1(ele.height) ? +ele.height : 1;
              volume = +(length * width * height);
            }
            if (name === "width") {
              const length = isValueThereT1(ele.length) ? +ele.length : 1;
              const width = isValueThereT1(value) ? +value : 0;
              const height = isValueThereT1(ele.height) ? +ele.height : 1;
              volume = +(length * width * height);
            }
            if (name === "height") {
              const length = isValueThereT1(ele.length) ? +ele.length : 1;
              const width = isValueThereT1(ele.width) ? +ele.width : 1;
              const height = isValueThereT1(value) ? +value : 0;
              volume = +(length * width * height) / 1000000;
            }
            const newEle = {
              ...ele,
              [name]: value,
              volume,
            };
            return newEle;
          } else {
            return ele;
          }
        }
      );

      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        material_packing_list: updateMaterialPackingList,
      };
      return updateState;
    });
  };

  handleGetSelectedHandlingInstructionsList = () => {
    const { createRequestPayload = {} } = this.state;
    const handling_instructions = createRequestPayload.handling_instructions;
    return handling_instructions;
  };

  handleToggleHandlingInstructions = (instructionEle) => {
    this.setState(
      (prevState) => {
        const updateState = { ...prevState };
        const handling_instructions =
          prevState.createRequestPayload.handling_instructions;
        let updateHandlingInstructions = [
          ...prevState.createRequestPayload.handling_instructions,
        ];
        const indexOfHandlingInstructionEle = handling_instructions.findIndex(
          (ele) => {
            if (ele === instructionEle.value) {
              return true;
            } else {
              return false;
            }
          }
        );

        if (indexOfHandlingInstructionEle < 0) {
          const updateHandlingInstructionsEle = instructionEle.value;
          updateHandlingInstructions.push(updateHandlingInstructionsEle);
        } else {
          updateHandlingInstructions.splice(indexOfHandlingInstructionEle, 1);
        }

        updateState.createRequestPayload = {
          ...prevState.createRequestPayload,
          handling_instructions: updateHandlingInstructions,
        };
        return updateState;
      },
      () => {
        if (instructionEle.value === 2) {
          this.handleOpenTemperatureCard();
        }
      }
    );
  };

  handleGetVehicleDetails = () => {
    const { createRequestPayload = {} } = this.state;
    const vehicle_details = createRequestPayload.vehicle_details;
    vehicle_details.label = vehicle_details.vehicle_type_name;
    vehicle_details.value = vehicle_details.vehicle_type;
    const C1 = !!!vehicle_details.vehicle_type_name;
    const C2 = !!!vehicle_details.vehicle_type;
    if (C1 && C2) {
      return null;
    }
    return vehicle_details;
  };

  handleOnChangeForVehicleDetails = (data) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      const updateVehicleDetails = {
        vehicle_type_name: !!data ? data.name : null,
        vehicle_type: !!data ? data.id : null,
      };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        vehicle_details: updateVehicleDetails,
      };
      return updateState;
    });
  };

  handleGetContactDetails = () => {
    const { createRequestPayload = {} } = this.state;
    const contact_details = createRequestPayload.contact_details;
    return contact_details;
  };

  handleOnChangeForContactDetails = (event) => {
    const { name, value } = event.target;
    if(name === 'contact_no' && value.length > 10) {
      return;
    }
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        contact_details: {
          ...prevState.createRequestPayload.contact_details,
          [name]: value,
        },
      };
      return updateState;
    });
  };

  handleOnChangeForUploadPackingListDoc = (file) => {
    const { dispatch } = this.props;

    const onSuccess = (data) => {
      this.setState((prevState) => {
        const updateState = { ...prevState };
        const supplierDocsList = [
          ...prevState.createRequestPayload.supplier_docs,
          data,
        ];
        updateState.createRequestPayload = {
          ...prevState.createRequestPayload,
          supplier_docs: supplierDocsList,
        };
        return updateState;
      });
    };

    dispatch({
      type: UPLOAD_DOCUMENT,
      file: file,
      onSuccess,
    });
  };

  handleGetSupplierDocsList = () => {
    const { createRequestPayload = {} } = this.state;
    const supplier_docs = createRequestPayload.supplier_docs;
    return supplier_docs;
  };

  handleOnClickForRemovePackingListDoc = (indexOfPLD) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      const supplierDocsList = prevState.createRequestPayload.supplier_docs.filter(
        (ele, indOfPLD) => {
          if (indOfPLD !== indexOfPLD) {
            return true;
          } else {
            return false;
          }
        }
      );

      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        supplier_docs: supplierDocsList,
      };
      return updateState;
    });
  };

  handleGetSupplierInstruction = () => {
    const { createRequestPayload = {} } = this.state;
    const supplier_instruction = createRequestPayload.supplier_instruction;
    return supplier_instruction;
  };

  handleOnChangeForSupplierInstruction = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        supplier_instruction: value,
      };

      return updateState;
    });
  };

  handleGetTentativePickupDate = () => {
    const { createRequestPayload = {} } = this.state;
    const tentative_pickup_date = createRequestPayload.tentative_pickup_date;
    return tentative_pickup_date;
  };

  handleOnDateChangeForTentativePickUpDate = (date) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        tentative_pickup_date: date,
      };
      return updateState;
    });
  };

  handleOnFocusChangeDatePickerForTentativePickUpDate = (focused) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.focusedDateForTentativePickUpDate = focused;
      return updateState;
    });
  };

  handleCreateRequestBtn = (isDraft = false , validateForm = true) => {
    const { createRequestPayload = {} } = this.state;
    const { dispatch, history } = this.props;
    const payload = {
      ...createRequestPayload,
    };
    let total_tare_weight = 0;
    let total_net_weight = 0;
    let total_gross_weight = 0;
    let total_volume = 0;

    const getTareWeight = (gross_weight = 0, net_weight = 0) => {
      if (!!!gross_weight && !!!net_weight) {
        return 0;
      }

      return gross_weight - net_weight;
    };

    payload.material_packing_list = payload.material_packing_list.map((ele) => {
      const newObj = {
        ...ele,
        packing_qty: isValueThere(ele.packing_qty) ? +ele.packing_qty : 0,
        // packing_unit: isValueThere(ele.packing_unit) ? +ele.packing_unit : 0,
        gross_weight: isValueThere(ele.gross_weight) ? +ele.gross_weight : 0,
        tare_weight: getTareWeight(
          isValueThere(ele.gross_weight) ? +ele.gross_weight : 0,
          isValueThere(ele.net_weight) ? +ele.net_weight : 0
        ),
        net_weight: isValueThere(ele.net_weight) ? +ele.net_weight : 0,
        length: isValueThere(ele.length) ? +ele.length : 0,
        width: isValueThere(ele.width) ? +ele.width : 0,
        height: isValueThere(ele.height) ? +ele.height : 0,
        volume: isValueThere(ele.volume) ? +ele.volume : 0,
      };

      total_tare_weight += newObj.tare_weight;
      total_net_weight += newObj.net_weight;
      total_gross_weight += newObj.gross_weight;
      total_volume += newObj.volume;

      return newObj;
    });

    payload.total_gross_weight = total_gross_weight;
    payload.total_tare_weight = total_tare_weight;
    payload.total_net_weight = total_net_weight;
    payload.total_volume = total_volume;

    payload.tentative_pickup_date = payload.tentative_pickup_date.valueOf();
    payload.is_draft = isDraft;

    // form validation SH

    if (validateForm && !this.isValidationForm(payload)) {
      return false;
    }

    // form validation EH

    
    // form validation SH

    if (validateForm && !this.isValidationForm(payload)) {
      return false;
    }

    // form validation EH




    const onSuccess = (data) => {
      dispatch({
        type: TOAST_SUCCESS,
        message:
          data && data.message
            ? data.message
            : "Contract created Successfully!!",
      });
      history.goBack();
    };

    dispatch({
      type: CREATE_SUPPLIER_CONTRACT,
      payload,
      onSuccess,
    });
  };

  handleUpdateRequestBtn = (validateForm = true) => {
    const { createRequestPayload = {} } = this.state;
    const { dispatch, history } = this.props;
    const payload = {
      ...createRequestPayload,
    };

    let total_tare_weight = 0;
    let total_net_weight = 0;
    let total_gross_weight = 0;
    let total_volume = 0;

    const getTareWeight = (gross_weight = 0, net_weight = 0) => {
      if (!!!gross_weight && !!!net_weight) {
        return 0;
      }
      return gross_weight - net_weight;
    };

    payload.material_packing_list = payload.material_packing_list.map((ele) => {
      const newObj = {
        ...ele,
        packing_qty: isValueThere(ele.packing_qty) ? +ele.packing_qty : 0,
        // packing_unit: isValueThere(ele.packing_unit) ? +ele.packing_unit : 0,
        gross_weight: isValueThere(ele.gross_weight) ? +ele.gross_weight : 0,
        tare_weight: getTareWeight(
          isValueThere(ele.gross_weight) ? +ele.gross_weight : 0,
          isValueThere(ele.net_weight) ? +ele.net_weight : 0
        ),
        net_weight: isValueThere(ele.net_weight) ? +ele.net_weight : 0,
        length: isValueThere(ele.length) ? +ele.length : 0,
        width: isValueThere(ele.width) ? +ele.width : 0,
        height: isValueThere(ele.height) ? +ele.height : 0,
        volume: isValueThere(ele.volume) ? +ele.volume : 0,
      };

      total_tare_weight += newObj.tare_weight;
      total_gross_weight += newObj.gross_weight;
      total_net_weight += newObj.net_weight;

      total_volume += newObj.volume;
      return newObj;
    });

    payload.total_gross_weight = total_gross_weight;
    payload.total_tare_weight = total_tare_weight;
    payload.total_net_weight = total_net_weight;
    payload.total_volume = total_volume;

    payload.tentative_pickup_date = payload.tentative_pickup_date.valueOf();
    payload.is_draft = false;

    // form validation SH

    if (validateForm && !this.isValidationForm(payload)) {
      return false;
    }

    // form validation EH


    // form validation SH

    if (validateForm && !this.isValidationForm(payload)) {
      return false;
    }

    // form validation EH


    const onSuccess = (data) => {
      dispatch({
        type: TOAST_SUCCESS,
        message:
          data && data.message
            ? data.message
            : "Contract Updated Successfully!!",
      });
      history.goBack();
    };

    dispatch({
      type: UPDATE_SUPPLIER_CONTRACT_DETAILS,
      payload,
      onSuccess,
    });
  };

  handleGetPackagingType = () => {
    const { createRequestPayload = {} } = this.state;
    const packagingType = {};
    packagingType.label = createRequestPayload.packing_type_name;
    packagingType.value = createRequestPayload.packing_type;

    const C1 = !!!packagingType.label;
    const C2 = !!!packagingType.value;

    if (C1 && C2) {
      return null;
    }

    return packagingType;
  };

  handleOnChangeForPackagingType = (data) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.createRequestPayload = {
        ...prevState.createRequestPayload,
        packing_type: !!data ? data.id : null,
        packing_type_name: !!data ? data.name : null,
      };

      return updateState;
    });
  };

  handleOnClickBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  isCreateRequestForm = () => {
    const { match } = this.props;
    const isCreateRequestForm = match.params.formType === "create";
    return isCreateRequestForm;
  };

  handleOnClickForSaveAndCloseBtn = () => {
    const isDraft = true;
    const validateForm = true;
    this.handleCreateRequestBtn(isDraft,validateForm)
  }

  handleOnClickForDiscardBtn = () => {
    const { dispatch, match, history } = this.props;

    const rfqId = match.params.rfqId;
    const rfqType = match.params.rfqType;

    const queryParams = {
      rfqId,
      rfqType,
    };

    const onSuccess = (data) => {
      dispatch({
        type: TOAST_SUCCESS,
        message:
          data && data.message
            ? data.message
            : "Contract Updated Successfully!!",
      });
      history.goBack();
    };

    dispatch({
      type: DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS,
      queryParams,
      onSuccess,
    });
  };

  downloadUploadedFile = (fileName) => {
    const { dispatch } = this.props;
    dispatch({
      type: DOWNLOAD_UPLOADED_FILE,
      param: {
        fileName,
      },
    });
  };

  handleOpenTemperatureCard = () => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      const isTemperatureSelected = prevState.createRequestPayload.handling_instructions.includes(
        2
      );
      if (isTemperatureSelected) {
        updateState.isTemperatureCardShown = true;
      }
      return updateState;
    });
  };

  handleCloseTemperatureCard = () => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.isTemperatureCardShown = false;
      return updateState;
    });
  };

  handleGetTemperatureDetails = () => {
    const { createRequestPayload } = this.state;
    let temperatureDetails = {
      temp_min: 0,
      temp_max: 0,
      temp_unit: 0,
    };

    temperatureDetails.temp_min = createRequestPayload.temp_min;
    temperatureDetails.temp_max = createRequestPayload.temp_max;
    temperatureDetails.temp_unit = createRequestPayload.temp_unit;

    return temperatureDetails;
  };

  handleSaveTemperatureDetails = (temp_min, temp_max, temp_unit) => {
    this.setState(
      (prevState) => {
        const updateState = { ...prevState };
        const temp_name = temp_unit === 2 ? "Fahrenheit" : "Celsius";
        updateState.createRequestPayload = {
          ...prevState.createRequestPayload,
          temp_min: +temp_min,
          temp_max: +temp_max,
          temp_unit: +temp_unit,
          temp_name: temp_name,
        };
        return updateState;
      },
      () => {
        this.handleCloseTemperatureCard();
      }
    );
  };

  isValidationForm = (payload) => {
    const { dispatch } = this.props;
    const source_address = (
      payload.consignor_details.source_address || ""
    ).trim();
    const location = (payload.consignor_details.location || "").trim();
    let materialFlag = false;

    if (!!!location) {
      toast({ dispatch, message: "Please Select From" });
      this.fromRef.current.focus();
      return false;
    }

    if (!!!source_address) {
      toast({ dispatch, message: "Please Fill Address" });
      this.addressRef.current.focus();
      return false;
    }

    (payload.material_packing_list || []).every(el => {
      const oKeys = Object.keys(el);
      oKeys.map(mObj => {
        if(!el[mObj] && !['package_number', 'remarks'].includes(mObj)) {
          materialFlag = true;
        }
      });
    });
    if(materialFlag || ((payload.material_packing_list || []).length === 0)) {
      toast({ dispatch, message: "Please Fill All The Fields In Cargo Description" });
      return false;
    }

    return true;
  };

  render() {
    const {
      loaderT1,
      consignorPickupLocationList,
      serviceTypesList,
      serviceModeTypesList,
      cargoDetailsTypesList,
      handlingInstructionTypesList,
      vehicleTypesList,
      packingTypesList,
    } = this.props;

    const { 
      statusTabBtnList, 
      focusedDateForTentativePickUpDate ,
      isTemperatureCardShown,
      isComponentDidMount
    } = this.state;

    console.log("this.state:", this.state);

    return (
      <Fragment>
        {loaderT1 && <ActionBlurLoader fixed={true} />}
        <div className="navBarWrapper">
          <Sticky></Sticky>
        </div>

        <PageWrapperT5>
          <BackButtonT1 onClick={this.handleOnClickBack} />
          <Spacer spacing={"14px"} />
          <CardT1
            consignorPickupLocationList={consignorPickupLocationList}
            handleOnChangeForPickupLocation={
              this.handleOnChangeForPickupLocation
            }
            consignor_details={this.handleGetConsignorDetails()}
            addressValue={this.handleGetAddressValue()}
            handleOnChangeAddress={this.handleOnChangeAddress}
            project_details={this.handleGetProjectDetails()}
            handleOnChangeForProjectDetails={
              this.handleOnChangeForProjectDetails
            }
            serviceTypesList={serviceTypesList}
            handleOnClickServiceType={this.handleOnClickServiceType}
            serviceTypeValue={this.handleGetServiceTypeValue()}
            serviceModeTypesList={serviceModeTypesList}
            service_mode={this.handleGetSelectedServiceModeList()}
            handleToggleServiceMode={this.handleToggleServiceMode}
            isComponentDidMount = {isComponentDidMount}
            fromRef = {this.fromRef}
            addressRef = {this.addressRef}
          />
          <Spacer spacing={"10px"} />
          <CardT2
            cargoDetailsTypesList={cargoDetailsTypesList}
            cargo_details={this.handleGetSelectedCargoDetailsList()}
            handleToggleCargoDetails={this.handleToggleCargoDetails}
            handleDownloadCargoMaterialPackingTemaplateFile={
              this.handleDownloadCargoMaterialPackingTemaplateFile
            }
            handleOnChangeForCargoMaterialPackingTemplateFile={
              this.handleOnChangeForCargoMaterialPackingTemplateFile
            }
            material_packing_list={this.handleGetMaterialPackingList()}
            handleOnClickForAddMaterialPackingBtn={
              this.handleOnClickForAddMaterialPackingBtn
            }
            handleOnClickForRemoveMaterialPackingBtn={
              this.handleOnClickForRemoveMaterialPackingBtn
            }
            handleOnChangeForMaterialPackingInputs={
              this.handleOnChangeForMaterialPackingInputs
            }
            handlingInstructionTypesList={handlingInstructionTypesList}
            handling_instructions={this.handleGetSelectedHandlingInstructionsList()}
            handleToggleHandlingInstructions={
              this.handleToggleHandlingInstructions
            }
            packingTypesList={packingTypesList}
            selectedPackagingType={this.handleGetPackagingType()}
            handleOnChangeForPackagingType={this.handleOnChangeForPackagingType}
            isTemperatureCardShown={isTemperatureCardShown}
            handleCloseTemperatureCard={this.handleCloseTemperatureCard}
            temperatureDetails={this.handleGetTemperatureDetails()}
            handleSaveTemperatureDetails={this.handleSaveTemperatureDetails}
          />
          <Spacer spacing={"10px"} />
          <CardT3
            vehicleTypesList={vehicleTypesList}
            vehicle_details={this.handleGetVehicleDetails()}
            handleOnChangeForVehicleDetails={
              this.handleOnChangeForVehicleDetails
            }
            contact_details={this.handleGetContactDetails()}
            handleOnChangeForContactDetails={
              this.handleOnChangeForContactDetails
            }
            tentative_pickup_date={this.handleGetTentativePickupDate()}
            focusedDateForTentativePickUpDate={
              focusedDateForTentativePickUpDate
            }
            handleOnDateChangeForTentativePickUpDate={
              this.handleOnDateChangeForTentativePickUpDate
            }
            handleOnFocusChangeDatePickerForTentativePickUpDate={
              this.handleOnFocusChangeDatePickerForTentativePickUpDate
            }
          />
          {/* <Spacer spacing={"10px"} />
          <CardT4
            handleOnChangeForUploadPackingListDoc={
              this.handleOnChangeForUploadPackingListDoc
            }
            supplier_docs={this.handleGetSupplierDocsList()}
            handleOnClickForRemovePackingListDoc={
              this.handleOnClickForRemovePackingListDoc
            }
            downloadUploadedFile = {this.downloadUploadedFile}
          /> */}
          <Spacer spacing={"10px"} />
          <CardT5
            supplier_instruction={this.handleGetSupplierInstruction()}
            handleOnChangeForSupplierInstruction={
              this.handleOnChangeForSupplierInstruction
            }
          />
          <Spacer spacing={"50px"} />
          <Footer
            handleCreateRequestBtn={() => this.handleCreateRequestBtn()}
            isCreateRequestForm={this.isCreateRequestForm()}
            handleUpdateRequestBtn={this.handleUpdateRequestBtn}
            handleOnClickForSaveAndCloseBtn={
              this.handleOnClickForSaveAndCloseBtn
            }
            handleOnClickForDiscardBtn={this.handleOnClickForDiscardBtn}
          />
        </PageWrapperT5>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loaderT1: !!state.common.loaderT1,
    consignorPickupLocationList:
      state.supplierRFQCreateOrUpdateRequest.consignorPickupLocationList || [],
    serviceTypesList:
      state.supplierRFQCreateOrUpdateRequest.serviceTypesList || [],
    serviceModeTypesList:
      state.supplierRFQCreateOrUpdateRequest.serviceModeTypesList || [],
    cargoDetailsTypesList:
      state.supplierRFQCreateOrUpdateRequest.cargoDetailsTypesList || [],
    cargoMaterialPackingTemaplateLink:
      state.supplierRFQCreateOrUpdateRequest
        .cargoMaterialPackingTemaplateLink || "",
    handlingInstructionTypesList:
      state.supplierRFQCreateOrUpdateRequest.handlingInstructionTypesList || [],
    vehicleTypesList:
      state.supplierRFQCreateOrUpdateRequest.vehicleTypesList || [],
    packingTypesList:
      state.supplierRFQCreateOrUpdateRequest.packingTypesList || [],
    supplierDetailsRfq:
      state.supplierRFQCreateOrUpdateRequest.supplierDetailsRfq || {},
  };
};

export default connect(mapStateToProps)(withRouter(SupplierRFQCreateRequest));
